import React from "react";
import { DefaultButton, MessageBar, MessageBarType, PrimaryButton, Separator, TextField, Spinner, SpinnerSize, Checkbox, Icon } from '@fluentui/react';
import { connect } from "react-redux";
import Person from "./Person";
import Progress from "./Progress";
import PersonalData from "./SiteEditElements/PersonalData";
import SensitivePersonalData from "./SiteEditElements/SensitivePersonalData";
import ExternalCollaboration from "./SiteEditElements/ExternalCollaboration";
import Confidentiality from "./SiteEditElements/Confidentiality";
import ExpirationDay from "./SiteEditElements/ExpirationDay";
import SecuredComponent from "./SiteEditElements/SecuredComponent";
import QuotaChange from "./SiteEditElements/QuotaChange";
import { SiteStatus, LocationType, SiteType, ProvisioningStatus, PermissionRole } from '../../GlobalConst/globalEnums';
import Api from '../../services/Api'
import DimensionPicker from "./SiteEditElements/DimensionPicker";
import SiteUrl from "./SiteEditElements/SiteUrl";
import { Pivot, PivotItem } from "@fluentui/react";
import SiteTasks from "./SiteTasks";
import CustomScript from "./SiteEditElements/CustomScript";
import DeleteRestoreBtn from "./SiteEditElements/DeleteRestoreBtn";
import SiteStatistics from "./SiteStatistics";
import TeamChannels from "./TeamChannels";
import SiteRedirects from "./SiteRedirects";
import CustomApplicationsList from "./SiteEditElements/CustomApplicationsList";
import GroupMail from './SiteEditElements/GroupMail'
import AppPermissions from "./AppPermissions";
import LoadingIcon from "../formFields/LoadingIcon";

class SiteEditor extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.tabs = {
            details: 'details',
            statistics: 'statistics',
            tasks: 'tasks',
            channels: 'channels',
            redirects: 'redirects',
            appPermissions: 'appPermissions'
        }

        this.state = {
            site: null,
            updateSet: [],
            updatedOwner: null,
            updatedCoOwners: [],
            approver: null,
            editable: false,
            onPremise: false,
            myOwnSite: false,
            coOwnedSite: false,
            messageVisible: false,
            error: false,
            isLoading: false,
            isMsTeams: false,
            isGroup: false,
            isGroupConnected: false,
            geography: null,
            management: null,
            isSaving: false,
            updatedProjectManager: [],
            updatedSponsor: [],
            updatedSteeringCommittee: [],
            isIATU: false,
            isOwnerChanged: false,
            isCoOwnersChanged: false,
            isProjectManagerChanged: false,
            isSponsorChanged: false,
            isSteeringCommitteeChanged: false,
            isChildrenUpdateValid: true,
            isOwnersValid: true,
            childrenValidation: {},
            isPWA: false,
            isPowerApp: false,
            hideDelete: false,
            selectedTab: this.tabs.details
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getSite(this.props.siteId);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSiteType(site) {

        this.setState({
            isMsTeams: site.siteTemplate.siteType === SiteType.team,
            isGroup: site.siteTemplate.siteType === SiteType.group,
            isGroupConnected: site.isGroupConnected
        });

        return site.isGroupConnected;
    }

    updateChangeWithCustomAction(key, value) {
        this.updateChange(key, value, () => this.customUpdateActions(key, value));
    }

    updateChange(key, value, callBack) {
        let set = this.state.updateSet;
        set = set.filter(x => x.key !== key);
        if (this.state.site[key] === value || value === null || !!this.state.site[key] === value) {
            this.setState({ updateSet: set }, callBack);
            return;
        }
        let myChange = { key: key, value: value };
        set.push(myChange);
        this.setState({ updateSet: set }, callBack);
    }

    updateChildrenValidation = (key, isValid) => {
        const childrenValidation = { ...this.state.childrenValidation, [key]: isValid };
        const isChildrenUpdateValid = Object.keys(childrenValidation).reduce((value, key) => {
            return value && childrenValidation[key];
        }, true);

        this.setState({
            isChildrenUpdateValid,
            childrenValidation
        });
    }

    updateOwnersValidation = () => {
        var owner = this.state.isOwnerChanged ? this.state.updatedOwner : this.state.site.owner;
        var coOwners = this.state.isCoOwnersChanged ? this.state.updatedCoOwners : this.state.site.coOwners;

        if(owner && coOwners.find(x => x.email === owner.email) !== undefined){
            this.setState({ updateOwnersErrorMessage: "Co-administrator must be different than administrator." });
            this.setState({ isOwnersValid: false });
        }
        else{
            this.setState({ updateOwnersErrorMessage: null });
            this.setState({ isOwnersValid: true });
        }
    }

    updateChangeDimension(key, value, callBack) {
        let set = this.state.updateSet;
        set = set.filter(x => x.key !== key);
        if (value != null && this.state.site.dimension && this.state.site.dimension[key] && this.state.site.dimension[key].code === value.key) {
            this.setState({ updateSet: set }, callBack);
            return;
        }
        let myChange = { key: key, value: value };
        set.push(myChange);
        this.setState({ updateSet: set }, callBack);
    }

    customUpdateActions(key, value) {
        if (key === "sensitiveGdpr" && value === true) {
            this.updateChange("gdpr", true)
        }

        if (key === "gdpr" && value === false) {
            this.updateChange("sensitiveGdpr", false);
        }
    }

    getUpdatedValue(key, defaultSet) {
        const set = this.state.updateSet;
        const result = set.filter(x => x.key === key);
        if (result.length === 0) {
            return defaultSet != null ? defaultSet[key] : null;
        }
        else {
            return result[0].value;
        }
    }

    editable() {
        this.setState({ editable: true });
        this.props.onEditChange(true)
    }

    pickGeoItem(hit) {
        this.setState({ geography: hit });
        this.updateChangeDimension("geographyKey", hit ? hit.key : '');
    }

    pickManItem(hit) {
        this.setState({ management: hit });
        this.updateChangeDimension("managementKey", hit ? hit.key : '');
    }

    setNewOwner(owners, getManager) {
        this.setState({ isOwnerChanged: true });
        this.setState({ updatedOwner: owners.length > 0 ? owners[0] : null },  this.updateOwnersValidation);
        if (getManager && owners && owners.length === 1) {
            const owner = owners[0];
            if (owner.manager) {
                this.setState({ approver: owner.manager});
            } else {
                this.getApprover(owner.id);
            }
        }
        else {
            this.setState({ approver: null });
        }
    }

    setNewCoOwner(coOwners) {
        this.setState({ isCoOwnersChanged: true });
        this.setState({ updatedCoOwners: coOwners }, this.updateOwnersValidation);
    }

    setNewProjectManager(projectManager) {
        this.setState({ isProjectManagerChanged: true });
        this.setState({ updatedProjectManager: projectManager });
    }

    setNewSponsor(sponsor) {
        this.setState({ isSponsorChanged: true });
        this.setState({ updatedSponsor: sponsor });
    }

    setNewSteeringCommittee(steeringCommittee) {
        this.setState({ isSteeringCommitteeChanged: true });
        this.setState({ updatedSteeringCommittee: steeringCommittee });
    }

    isRequestBlocked() {
        return this.state.onPremise 
            && this.state.isOwnerChanged
            && this.state.updatedOwner
            && !this.state.approver 
            && !this.state.isLoading;
    }

    getSite(siteId) {
        this.setState({ isLoading: true });

        Api.get(`/Site?id=${siteId}`)
            .then(res => res.data)
            .then(site => {
                if(this._isMounted) {
                    const isGroupConnected = this.setSiteType(site);
                    this.setState({
                        site,
                        isLoading: false,
                        onPremise: site.farmLocation.locationType === LocationType.onPremise,
                        myOwnSite: this.isMySite(site.owner),
                        coOwnedSite: this.isCoOwnedSite(site.coOwners),
                        geography: site.dimension ? site.dimension.geography : null,
                        management: site.dimension ? site.dimension.management : null,
                        isIATU: site.customSite && site.customSite.siteIATU ? true : false,
                        isIAPCP: site.customSite && site.customSite.siteIAPCP ? true : false,
                        isPWA: site.siteTemplate.spTemplateName === "PWA#0" ? true : false
                    });
                    
                    if (!isGroupConnected && site.owner) {
                        this.getApprover(site.owner.userId);
                    }
                }
            });
    }

    isMySite(owner) {
        return owner != null && owner.userId === this.props.userId;
    }

    isCoOwnedSite(coOwners) {
        return coOwners.filter(x => x.userId === this.props.userId).length !== 0;
    }

    isEmptyOwnerUpdated() {
        return (this.state.site.owner == null || this.state.site.owner.isDeleted) && this.state.isOwnerChanged && this.state.updatedOwner !== null;
    }

    getApprover(userId) {
        this.setState({ isLoading: true });

        Api.get(`/User/Manager?userId=${userId}`)
            .then(res => res.data)
            .then(user => {
                if(this._isMounted) {
                    this.setState({ approver: user, isLoading: false });
                }
            });
    }

    eraseSelection() {
        let update = this.buildUpdate();
        update.dimension = {
            geography: update.geography ? update.geography : (this.state.site.dimension ? this.state.site.dimension.geography : null),
            management: update.management ? update.management : (this.state.site.dimension ? this.state.site.dimension.management : null)
        };
        if (update.extension) {
            update.expirationDate = new Date(new Date().setFullYear(new Date().getFullYear() + update.extension)).toISOString();
        }
        this.setState({
            site: { ...this.state.site, ...update },
            updateSet: [],
            updatedCoOwners: [],
            editable: false,
            error: false
        })
        this.props.onEditChange(false)
    }

    buildUpdate() {
        let command = {
            id: this.props.siteId
        };
        const updateSet = this.state.updateSet;
        updateSet.map(x => command[x.key] = x.value);

        if (this.state.isOwnerChanged && (this.state.site.owner == null || this.state.updatedOwner.id !== this.state.site.owner.userId)) {
            command.owner = this.state.updatedOwner;
        }

        if (this.state.isCoOwnersChanged) {
            command.coOwners = this.state.updatedCoOwners.map(x => ({ ...x, id: x.userId ? x.userId : x.id }));
        }

        if (this.state.updatedCoOwners.length) {
            command.approver = this.state.approver;
        }

        if (this.state.isProjectManagerChanged) {
            command.projectManager = this.state.updatedProjectManager.map(x => ({ ...x, id: x.userId ? x.userId : x.id }));
        }

        if (this.state.isSponsorChanged) {
            command.sponsor = this.state.updatedSponsor.map(x => ({ ...x, id: x.userId ? x.userId : x.id }));
        }

        if (this.state.isSteeringCommitteeChanged) {
            command.steeringCommittee = this.state.updatedSteeringCommittee.map(x => ({ ...x, id: x.userId ? x.userId : x.id }));
        }

        return command;
    }

    updateSite() {

        let address = '/UpdateSiteRequest';

        if (this.isRequestBlocked())
            return;

        this.setState({ error: false, messageVisible: false, isLoading: true, isSaving: true });
        let update = this.buildUpdate();

        this.eraseSelection();

        Api.post(address, update)
            .then(res => res.data)
            .then(post => {
                this.setState({ isLoading: false, isSaving: false });
                if (post === 200) {
                    this.setState({ isOwnerChanged: false });
                    this.setState({ isCoOwnersChanged: false });
                    this.setState({ isProjectManagerChanged: false });
                    this.setState({ isSponsorChanged: false });
                    this.setState({ isSteeringCommitteeChanged: false });
                    this.setState({ messageVisible: true });
                    if (this.props.callBack)
                        this.props.callBack(this.props.siteId);
                } else {
                    this.setState({ error: true })
                }
            }
            ).catch((error) => {
                console.log(error)
            })
    }

    saveEnable() {
        return !this.state.isLoading
            && (this.state.updateSet.length !== 0
                || (this.state.isOwnerChanged && this.state.updatedOwner !== null && (this.state.site.owner == null || this.state.updatedOwner.id !== this.state.site.owner.userId))
                || this.state.isCoOwnersChanged
                || (this.state.isProjectManagerChanged && this.state.updatedProjectManager.length > 0)
                || this.state.isSponsorChanged
                || this.state.isSteeringCommitteeChanged)
            && (this.state.isOwnerChanged === (this.state.updatedOwner !== null))
            && this.state.management
            && this.state.geography
            && !this.isRequestBlocked()
            && !this.state.isSaving
            && (new Date(this.state.site.expirationDate) > Date.now() || this.getUpdatedValue('extension') || this.getUpdatedValue('keepReadOnly'))
            && this.state.isChildrenUpdateValid
            && this.state.isOwnersValid
            && ((this.state.site.owner != null && !this.state.site.owner.isDeleted) || this.isEmptyOwnerUpdated())
    }

    editEnabled() {
        return !this.state.isSaving 
            && !this.state.messageVisible 
            && !this.state.editable
            && ((this.state.site.owner !== null && this.state.site.owner.userId === this.props.userId && this.state.site.provisioningStatus !== ProvisioningStatus.updating) || this.props.currentUser.role === PermissionRole.administrator)
            && this.state.site.siteStatus !== SiteStatus.deleted 
            && (this.state.site.siteStatus !== SiteStatus.disabled || this.state.site.keepReadOnly)
            && this.state.site.url
            && this.state.site.farmLocation.enableSiteEdit
            && this.state.site.provisioningStatus !== ProvisioningStatus.ms365Archived;
    }

    changeStatus = (actionType, comment) => {

        this.setState({ error: false, messageVisible: false, isSaving: true, hideDelete: true });
        const post = {
            id: this.props.siteId,
            changeStatusAction: actionType,
            restoreBusinessJustification: comment
        };

        this.eraseSelection();

        Api.post('/UpdateSiteRequest', post)
            .then(res => res.data)
            .then(post => {
                if (post === 200) {
                    this.setState({ messageVisible: true, isSaving: false })
                    if (this.props.callBack)
                        this.props.callBack(this.props.siteId);
                } else {
                    this.setState({ error: true })
                    console.log("Update failed")
                }
            }
            ).catch((error) => {
                console.log(error)
            })
    }

    _onTabChanged = (item, ev) => {
        this.setState({selectedTab: item.props.itemKey})
    }

    render() {
        const disabled = !this.state.editable;

        const projectManager = (this.state.isIATU || this.state.isIAPCP) ? <Person
            limited={true}
            userType='Project Manager'
            updateType="projectManager"
            onChange={this.setNewProjectManager.bind(this)}
            disabled={disabled}
            user={this.state.isProjectManagerChanged ? this.state.updatedProjectManager
                : (this.state.isIATU ? this.state.site.customSite.siteIATU.projectManager : this.state.site.customSite.siteIAPCP.projectManager)}
            isRequired={true}
        /> : <div></div>;

        const sponsor = (this.state.isIATU || this.state.isIAPCP) ? <Person
            limited={!this.state.isIAPCP}
            userType='Sponsor'
            updateType="sponsor"
            onChange={this.setNewSponsor.bind(this)}
            disabled={disabled}
            user={this.state.isSponsorChanged ? this.state.updatedSponsor
                : (this.state.isIATU ? this.state.site.customSite.siteIATU.sponsor : this.state.site.customSite.siteIAPCP.sponsor)}
            isRequired={false}
        /> : <div></div>;

        const steeringCommitee = (this.state.isIATU || this.state.isIAPCP) ? <Person
            limited={false}
            userType='Steering Committee'
            updateType="steeringCommittee"
            onChange={this.setNewSteeringCommittee.bind(this)}
            disabled={disabled}
            user={this.state.isSteeringCommitteeChanged ? this.state.updatedSteeringCommittee
                : (this.state.isIATU ? this.state.site.customSite.siteIATU.steeringCommittee : this.state.site.customSite.siteIAPCP.steeringCommittee)}
            isRequired={false}
        /> : <div></div>;

        const btnIconEdit = this.state.site && this.state.selectedTab === this.tabs.details &&
            <Icon style={{fontSize: 17}} iconName='edit' onClick={this.editable.bind(this)} />   
        
        const messageBar =
            <div>
                {
                    this.isRequestBlocked() &&
                    <MessageBar
                        dismissButtonAriaLabel="Close"
                        truncated={true}
                        messageBarType={MessageBarType.error}>
                        Your change request can not be processed. Please contact Support to fill in your Line Manager in organization structure.
                    </MessageBar>
                }
                {
                    this.state.error &&
                    <MessageBar
                        dismissButtonAriaLabel="Close"
                        truncated={true}
                        messageBarType={MessageBarType.error}>
                        We can not proceed your change request.
                    </MessageBar>
                }
                {
                    this.state.messageVisible &&
                    <MessageBar
                        dismissButtonAriaLabel="Close"
                        truncated={true}
                        messageBarType={MessageBarType.success}>
                        Your change request has been received.
                    </MessageBar>
                }
            </div>
        
        const siteTitle = this.state.site && 
            <div className="site-editor-header">
                <div className="site-editor-title" title={this.state.site.title}>
                    {this.state.site.title.length > 53 ? `${this.state.site.title.substr(0, 50)}...` : this.state.site.title}
                </div>
                <div className="site-editor-icon" onClick={this.props.onRequestClose}><Icon iconName="chromeClose" /></div>
                {this.editEnabled() && <div className="site-editor-icon">{btnIconEdit}</div>}
                {messageBar}
            </div>

        const editor = this.state.site && <div className="site-editor">
                <div>
                    <div style={{ width: '100%', minHeight: '40px', wordBreak: 'break-all', marginTop: '10px' }}>
                        {
                            this.state.site.url
                                ? <SecuredComponent
                                        readSecurityLevel='Reader'
                                        editSecurityLevel='Administrator'
                                        readOnlyAccess={this.state.myOwnSite || this.state.coOwnedSite}
                                  >
                                    <SiteUrl
                                        url={this.state.site.url}
                                        disabled={disabled || this.state.isPWA || this.state.site.litigationHold}
                                        onChange={this.updateChange.bind(this)}
                                        onValidation={this.updateChildrenValidation}
                                        isOnPremise={this.state.onPremise}
                                        tooltip={(this.state.isPWA && 'URL cannot be changed for Project Online site.') || (this.state.site.litigationHold && 'URL cannot be changed for site with Litigation Hold enabled.')}
                                    />
                                  </SecuredComponent>
                                : <TextField
                                    autoComplete="off"
                                    type="text"
                                    disabled={true}
                                    defaultValue={`${this.state.site.farmLocation.address}/${this.state.isGroupConnected ? 'teams' : 'sites'}/${this.state.site.name}`}
                                />
                        }
                    </div>
                    {
                        this.state.site.url && this.state.site.groupMail &&
                        <div style={{ width: '100%', minHeight: '40px', wordBreak: 'break-all', marginTop: '5px' }}>
                                <SecuredComponent
                                    readSecurityLevel='Reader'
                                    editSecurityLevel='Administrator'
                                    readOnlyAccess={this.state.myOwnSite || this.state.coOwnedSite}
                                >
                                    <GroupMail
                                        mail={this.state.site.groupMail}
                                        disabled={disabled}
                                        onChange={this.updateChange.bind(this)}
                                        onValidation={this.updateChildrenValidation}
                                    />
                                </SecuredComponent>
                        </div>
                    }
                    <div>
                        {
                            <div style={ownerStyle}>
                                <SecuredComponent readSecurityLevel='Reader'
                                    editSecurityLevel='Contributor'
                                    readOnlyAccess={this.state.coOwnedSite}
                                    unlimitedAccess={this.state.myOwnSite}
                                >
                                    <Person
                                        limited={true}
                                        userType='Administrator'
                                        updateType="owner"
                                        onChange={(owners) => this.setNewOwner(owners, !this.state.isGroupConnected)}
                                        disabled={disabled}
                                        user={this.state.isOwnerChanged ? this.state.updatedOwner : this.state.site.owner}
                                        isRequired={true}
                                    />
                                </SecuredComponent>
                            </div>
                        }
                        {
                            !this.state.isGroupConnected &&
                            <div style={approverStyle}>
                                <SecuredComponent readSecurityLevel='Reader'
                                    editSecurityLevel='Contributor'
                                    readOnlyAccess={this.state.coOwnedSite}
                                    unlimitedAccess={this.state.myOwnSite}
                                >
                                    <Person
                                        updateType="siteApprover"
                                        disabled={true}
                                        userType='Approver'
                                        user={this.state.approver}
                                    />
                                </SecuredComponent>
                            </div>
                        }
                        {
                            <div style={coOwnersStyle}>
                                <SecuredComponent readSecurityLevel='Reader'
                                    editSecurityLevel='Contributor'
                                    readOnlyAccess={this.state.coOwnedSite}
                                    unlimitedAccess={this.state.myOwnSite}
                                >
                                    <Person
                                        limited={false}
                                        userType={'Co-Administrators'}
                                        updateType="coOwner"
                                        onChange={(coOwners) => this.setNewCoOwner(coOwners)}
                                        disabled={disabled}
                                        user={this.state.updatedCoOwners.length ? this.state.updatedCoOwners : this.state.site.coOwners}
                                        isRequired={false}
                                        errorMessage={this.state.updateOwnersErrorMessage}
                                    />
                                    {projectManager}
                                    {sponsor}
                                    {steeringCommitee}
                                </SecuredComponent>
                            </div>
                        }
                    </div>
                    <div style={{ width: '43%', marginRight: '7%', float: 'left', clear: 'both', marginBottom:'20px' }}>
                        <div style={{ position: 'relative' }}>
                            <SecuredComponent readSecurityLevel='Reader'
                                editSecurityLevel='Contributor'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                            >
                                <DimensionPicker
                                    itemSelector={this.pickGeoItem.bind(this)}
                                    searchTitle="Site Audience"
                                    searchDataUrl='/Geography'
                                    isDisabled={disabled}
                                    selection={this.state.geography}
                                    isRequired={true}
                                    treeDataUrl='/Geography'
                                    dimensionConfig={(this.state.site.siteTemplate.config || {}).geographyConfig || {}}
                                    includeCrossOrg={true}
                                    //additionalOptions={[{ key: 'Cross', value: 'Cross Organisation' }]}
                                />
                            </SecuredComponent>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <SecuredComponent readSecurityLevel='Reader'
                                editSecurityLevel='Contributor'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                            >
                                <DimensionPicker
                                    itemSelector={this.pickManItem.bind(this)}
                                    searchTitle="Management"
                                    searchDataUrl='/Management'
                                    isDisabled={disabled}
                                    selection={this.state.management}
                                    isRequired={true}
                                    treeDataUrl='/Management'
                                    dimensionConfig={(this.state.site.siteTemplate.config || {}).managementConfig || {}}
                                />
                            </SecuredComponent>
                        </div>
                    </div>
                    {
                        this.state.site.quotaValue !== 0 &&
                        <div style={this.state.isGroupConnected ? quotaAreaTeams : quotaAreaSites}>
                            Quota usage
                            <Progress usage={this.state.site.quotaUsage}
                                quota={this.state.site.quotaValue}
                            />

                            <SecuredComponent
                                readSecurityLevel='Reader'
                                editSecurityLevel='Contributor'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                            >
                                <QuotaChange
                                    onUpdate={this.updateChange.bind(this)}
                                    disabled={disabled}
                                    defaultQuota={this.state.site.quotaValue}
                                    location={this.state.site.farmLocation}
                                />
                            </SecuredComponent>
                        </div>
                    }
                    <SecuredComponent readSecurityLevel='Reader'>
                        <div style={{paddingBottom: '10px', clear: 'both'}}>
                            <span>Site Template: {this.state.site.siteTemplate.name}</span>
                        </div>
                    </SecuredComponent>
                    { 
                        this.state.site.customApplications.length > 0 &&
                        <SecuredComponent readSecurityLevel='Reader'>
                            <div style={{paddingBottom: '10px'}}>
                                <div>Custom Applications:</div>
                                <CustomApplicationsList apps={this.state.site.customApplications} />
                            </div>
                        </SecuredComponent>
                    }
                    <div style={{ marginTop: '10px', display: 'flex', clear: 'both' }}>
                        <SecuredComponent readSecurityLevel='Reader'
                            editSecurityLevel='Contributor'
                            readOnlyAccess={this.state.coOwnedSite}
                            unlimitedAccess={this.state.myOwnSite}
                        >
                            <ExpirationDay
                                onUpdate={this.updateChange.bind(this)}
                                disabled={disabled}
                                extension={this.getUpdatedValue('extension')}
                                expirationDate={this.state.site.expirationDate}
                                keepReadOnly={this.getUpdatedValue('keepReadOnly')}
                                emptyOwnerUpdated={this.isEmptyOwnerUpdated()}
                            />
                        </SecuredComponent>
                        {
                        this.state.site.provisioningStatus !== ProvisioningStatus.noAccess &&
                        <SecuredComponent
                            readSecurityLevel='Administrator'
                            editSecurityLevel='Administrator'>
                                <Checkbox 
                                    label="Keep site in read-only mode (Disabled/Read only)" 
                                    checked={this.getUpdatedValue('keepReadOnly', this.state.site)}
                                    onChange={(ev, isChecked) => this.updateChange('keepReadOnly', isChecked)}
                                    disabled={disabled}
                                    styles={{root: {bottom: '5px', marginLeft: '26px', alignItems: 'flex-end'}}}
                                />
                        </SecuredComponent>
                        }
                    </div>
                    <div style={{ marginTop: '30px' }}>
                        General Data Processing Regulations:
                    </div>
                    <SecuredComponent
                        readSecurityLevel='Reader'
                        editSecurityLevel='Contributor'
                        readOnlyAccess={this.state.coOwnedSite}
                        unlimitedAccess={this.state.myOwnSite}
                    >
                        <PersonalData
                            onUpdate={this.updateChangeWithCustomAction.bind(this)}
                            disabled={disabled}
                            gdpr={this.getUpdatedValue('gdpr', this.state.site)}
                        />
                    </SecuredComponent>
                    <SecuredComponent
                        readSecurityLevel='Reader'
                        editSecurityLevel='Contributor'
                        readOnlyAccess={this.state.coOwnedSite}
                        unlimitedAccess={this.state.myOwnSite}
                    >
                        <SensitivePersonalData
                            onUpdate={this.updateChangeWithCustomAction.bind(this)}
                            disabled={disabled || !this.getUpdatedValue('gdpr', this.state.site)}
                            sensitiveGdpr={this.getUpdatedValue('sensitiveGdpr', this.state.site)}
                        />
                    </SecuredComponent>
                    {!this.state.onPremise &&
                        <div style={{ marginTop: '30px' }}>
                            <SecuredComponent
                                readSecurityLevel='Reader'
                                editSecurityLevel='Contributor'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                            >
                                <ExternalCollaboration
                                    onUpdate={this.updateChange.bind(this)}
                                    disabled={disabled || this.state.isMsTeams}
                                    externalCollaboration={this.state.site.externalCollaboration}
                                />
                            </SecuredComponent>
                            {
                                this.state.isMsTeams &&
                                <div className='infoMessage'>External sharing is enabled on every MS Team</div>
                            }
                        </div>
                    }
                    <div>
                        <div style={{ marginTop: '30px'}}>
                            <SecuredComponent readSecurityLevel='Administrator'
                                editSecurityLevel='Administrator'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                                >
                                <CustomScript
                                    onUpdate={this.updateChange.bind(this)}
                                    disabled={disabled}
                                    customScript={this.getUpdatedValue('customScriptAllowed', this.state.site)}
                                />
                            </SecuredComponent>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: '30px' }}>
                            <SecuredComponent readSecurityLevel='Reader'
                                editSecurityLevel='Contributor'
                                readOnlyAccess={this.state.coOwnedSite}
                                unlimitedAccess={this.state.myOwnSite}
                            >
                                <Confidentiality
                                    onUpdate={this.updateChange.bind(this)}
                                    disabled={disabled}
                                    level={this.state.site.confidentiality}
                                />
                            </SecuredComponent>
                        </div>                  
                    </div>
                    <Separator styles={{ root: { margin: '10px 0' } }} />             
                    <div>
                        <SecuredComponent readSecurityLevel='Contributor'
                            unlimitedAccess={this.state.myOwnSite}>
                            <div style={{ marginTop: '20px', display: "flex", justifyContent: "space-between"}}>
                                <div>
                                {
                                    this.editEnabled() && 
                                    <DefaultButton className="edit-icon" onClick={this.editable.bind(this)}> Edit </DefaultButton>
                                }
                                {
                                    this.state.editable && !this.editEnabled() && 
                                    <PrimaryButton className="edit-icon" onClick={this.updateSite.bind(this)} disabled={!this.saveEnable()}> Make change request </PrimaryButton>
                                }
                                </div>
                                {
                                    !this.state.hideDelete &&
                                    <DeleteRestoreBtn site={this.state.site} myOwnSite={this.state.myOwnSite} changeStatus={this.changeStatus} currentUser={this.props.currentUser} />
                                }
                            </div>
                        </SecuredComponent>
                    </div>
                    <div className="edit-panel">
                        {
                            this.state.isSaving && 
                                <Spinner style={{ float: 'left' }} size={SpinnerSize.medium} />
                        }
                    </div>
                </div>
            </div>

        return (
            this.state.isLoading && !this.state.site
            ? <LoadingIcon />
            :
            <div>
                {siteTitle}
                <div className='site-editor-container'>
                    <Pivot onLinkClick={this._onTabChanged} selectedKey={this.state.selectedTab}>
                        <PivotItem itemKey={this.tabs.details} headerText="Details">
                            {editor}
                        </PivotItem>
                        <PivotItem itemKey={this.tabs.statistics} headerText="Statistics">
                        {
                            this.state.site && this.state.site.statistics &&
                            <SiteStatistics statistics={this.state.site.statistics} />
                        }
                        </PivotItem>
                        {
                            this.props.currentUser.role === PermissionRole.administrator&& 
                            <PivotItem itemKey={this.tabs.tasks} headerText="Tasks">
                                <SiteTasks site={this.state.site}/>
                            </PivotItem>
                        }
                        {
                            this.state.site && this.state.site.channels.length > 0 && 
                            <PivotItem itemKey={this.tabs.channels} headerText="Private & Shared channels">
                                <TeamChannels site={this.state.site}/>
                            </PivotItem>
                        }
                        {
                            this.props.currentUser.role === PermissionRole.administrator && this.state.site && this.state.site.siteRedirects.length > 0 && 
                            <PivotItem itemKey={this.tabs.redirects} headerText="Site Redirects">
                                <SiteRedirects site={this.state.site} refresh={this.getSite.bind(this)}/>
                            </PivotItem>
                        }
                        {
                            this.state.site && 
                            <PivotItem itemKey={this.tabs.appPermissions} headerText="App Permissions">
                                <AppPermissions site={this.state.site} refresh={this.getSite.bind(this)}/>
                            </PivotItem>
                        }
                    </Pivot>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userId: state.user.currentUser.id,
    currentUser: state.user.currentUser
})

const quotaAreaSites = {
    // position:'absolute',
    // left:'50%',
    // top: '114px',
    // height:'60px',
    float: 'left',
    marginTop: '10px',
    width: '43%',
    marginRight: '7%'
}

const quotaAreaTeams = {
    // position:'absolute',
    // left:'50%',
    // top: '184px',
    // height:'60px',
    float: 'left',
    marginTop: '10px',
    width: '43%',
    marginRight: '7%'
}

const ownerStyle = {
    width: '43%',
    // marginTop: '10px',
    float: 'left',
    marginRight: '7%'
}

const coOwnersStyle = {
    width: '100%',
    float: 'left'
}

const approverStyle = {
    width: '43%',
    // marginTop: '10px',
    float: 'left'
}

export default connect(mapStateToProps, null)(SiteEditor)



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditor.js